export interface ToastMessage {
  id: number
  text: string
}

let nextId = 1

export function useToast() {
  const toasts = useState<ToastMessage[]>('toasts', () => [])

  function show(text: string, duration = 4000) {
    const id = nextId++
    toasts.value.push({ id, text })
    setTimeout(() => {
      const i = toasts.value.findIndex((t) => t.id === id)
      if (i !== -1) toasts.value.splice(i, 1)
    }, duration)
  }

  return { toasts, show }
}
